import { AppNotification } from '@app/common';
import { makeAutoObservable } from 'mobx';
import type { RootStore } from './root-store';
import type { NotificationStore } from './notification-store';

export class NotificationDialogStore {
    rootStore: RootStore;

    notification: AppNotification | null = null;

    opened = false;

    constructor(notificationStore: NotificationStore) {
        this.rootStore = notificationStore.rootStore;

        makeAutoObservable(this, {
            rootStore: false,
        });
    }

    open(notification: AppNotification): void {
        this.notification = notification;
        this.opened = true;
        this.rootStore.alertStore.setModalPlacement();
    }

    close(): void {
        this.notification = null;
        this.opened = false;
        this.rootStore.alertStore.setDefaultPlacement();
    }
}
